import 'bundles/core';
import 'bundles/video/lockSlateTracking';
import 'shared/sentry.io-video';
import 'bundles/livetv/GPPHandler';
import 'bundles/livetv/OptanonNPAFlagHandler';
import FreeWheelFMS from 'services/FreeWheelFMS';
import SmartTagPlayer from 'video/smart-tag-player';

window.CBSPlayer = {
    FreeWheelFMS: FreeWheelFMS,
    SmartTagPlayer: SmartTagPlayer,
};

window.onkeydown = function (e) {
    return !(e.keyCode == 32 && e.target == document.body);
};
